import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const C = {
  navy: '#0E1512',
  navyDeep: '#0A0F0D',
  green: '#2EE06B',
  ink: '#0E1512',
  inkSoft: '#9CA8A2',
  cloud: '#F4F7F5',
  border: 'rgba(255,255,255,0.08)'
};

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

export default function Sidebar({ active }) {
  const { user, logout } = useAuth();
  const [userRole, setUserRole] = useState(() => localStorage.getItem('winal_role') || null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();

  const firstName = user?.displayName?.split(' ')[0] || 'Usuario';

  useEffect(() => {
    const loadRole = async () => {
      if (user?.email) {
        try {
          const res = await api.get(`/users/email/${encodeURIComponent(user.email)}`);
          const role = res.data.role;
          setUserRole(role);
          localStorage.setItem('winal_role', role);
        } catch (e) {}
      }
    };
    loadRole();
  }, [user]);

  useEffect(() => { setMobileOpen(false); }, [active]);

  const linkStyle = (name) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 14px', borderRadius: 8, fontSize: 13.5,
    fontFamily: "'Nunito', sans-serif",
    fontWeight: active === name ? 800 : 700,
    color: active === name ? C.green : C.inkSoft,
    background: active === name ? 'rgba(46,224,107,0.16)' : 'transparent',
    textDecoration: 'none', cursor: 'pointer', border: 'none',
    width: '100%', textAlign: 'left'
  });

  const isSuperAdmin = userRole === 'superadmin';

  const NavContent = () => (
    <>
      <div style={{ padding: '20px 16px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <img src="/logo.png" alt="Winal" style={{ width: 38, height: 38, objectFit: 'contain' }} />
        </div>
        {isMobile && (
          <button onClick={() => setMobileOpen(false)} style={{ background: 'transparent', border: 'none', color: C.inkSoft, fontSize: 22, cursor: 'pointer', padding: 4 }}>✕</button>
        )}
      </div>

      <nav style={{ flex: 1, padding: '14px 10px', display: 'flex', flexDirection: 'column', gap: 3, overflowY: 'auto' }}>

        <a href="/dashboard" style={linkStyle('dashboard')}>
          <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
          </svg>
          Eventos
        </a>

        {userRole === 'negocio' && (
          <>
            <a href="/canchas" style={linkStyle('canchas')}>
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
              </svg>
              Mis canchas
            </a>
            <a href="/negocio-perfil" style={linkStyle('negocio-perfil')}>
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Datos del negocio
            </a>
          </>
        )}

        {isSuperAdmin && (
          <>
            <div style={{ height: 1, background: C.border, margin: '8px 4px' }}/>
            <a href="/superadmin" style={{
              ...linkStyle('superadmin'),
              color: active === 'superadmin' ? '#FFC857' : '#FFC857',
              background: active === 'superadmin' ? 'rgba(255,200,87,0.14)' : 'transparent'
            }}>
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
              Super Admin
            </a>
          </>
        )}

      </nav>

      <div style={{ borderTop: `1px solid ${C.border}` }}>
        <a href="/profile" style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', borderRadius: 8, margin: '6px 8px', background: active === 'profile' ? 'rgba(46,224,107,0.16)' : 'transparent' }}>
          {user?.photoURL ? (
            <img src={user.photoURL} alt="avatar" style={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: `2px solid ${C.border}` }}/>
          ) : (
            <div style={{ width: 30, height: 30, background: C.green, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11.5, fontFamily: "'Nunito', sans-serif", fontWeight: 800, color: C.cloud, flexShrink: 0 }}>
              {firstName.slice(0,2).toUpperCase()}
            </div>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 800, fontFamily: "'Nunito', sans-serif", color: C.cloud, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{firstName}</div>
            <div style={{ fontSize: 11, color: C.inkSoft }}>{userRole || 'Usuario'}</div>
          </div>
        </a>

        <div style={{ padding: '0 16px 14px' }}>
          <button onClick={() => { localStorage.removeItem('winal_role'); logout(); }} style={{
            width: '100%', background: 'transparent',
            border: `1px solid ${C.border}`, borderRadius: 8,
            padding: '8px', color: C.inkSoft, fontSize: 12, fontFamily: "'Nunito', sans-serif", fontWeight: 700, cursor: 'pointer'
          }}>
            Salir
          </button>
        </div>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <>
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, height: 56,
          background: C.navy, borderBottom: `1px solid ${C.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 16px', zIndex: 100
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <img src="/logo.png" alt="Winal" style={{ width: 34, height: 34, objectFit: 'contain' }} />
          </div>
          <button onClick={() => setMobileOpen(true)} style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            display: 'flex', flexDirection: 'column', gap: 5, padding: 4
          }}>
            <div style={{ width: 22, height: 2, background: C.cloud, borderRadius: 2 }}/>
            <div style={{ width: 22, height: 2, background: C.cloud, borderRadius: 2 }}/>
            <div style={{ width: 22, height: 2, background: C.cloud, borderRadius: 2 }}/>
          </button>
        </div>

        {mobileOpen && (
          <div onClick={() => setMobileOpen(false)}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 150 }}
          />
        )}

        <div style={{
          position: 'fixed', top: 0, left: 0, bottom: 0, width: 250,
          background: C.navy, borderRight: `1px solid ${C.border}`,
          display: 'flex', flexDirection: 'column',
          transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.25s ease',
          zIndex: 200, overflowY: 'auto'
        }}>
          <NavContent />
        </div>
      </>
    );
  }

  return (
    <div style={{
      width: 210, minHeight: '100vh', background: C.navy,
      borderRight: `1px solid ${C.border}`,
      display: 'flex', flexDirection: 'column',
      position: 'fixed', left: 0, top: 0, zIndex: 50
    }}>
      <NavContent />
    </div>
  );
}